import styled, { css } from 'styled-components';

type StyledMiscLayoutFooterProps = {
  $isFixedToBottom?: boolean;
};

function isFixedToBottomStyle({ $isFixedToBottom }: StyledMiscLayoutFooterProps) {
  if ($isFixedToBottom) {
    return css`
      position: fixed;
      bottom: 0;
      width: 100%;
    `;
  }
}

export default styled.div<StyledMiscLayoutFooterProps>`
  ${isFixedToBottomStyle}
`;
